import { put, call, take, fork } from 'redux-saga/effects';
import { importCourseExcelService } from '../../api/assignment';
//import { questionPatchSuccess } from '../../reducers/question/action'
import { importCourseExcelSuccess } from '../../reducers/assignment/action';
import { IMPORT_COURSE_EXCEL } from '../../reducers/assignment/type';
import generalSaga from '../general';
import { operationSuccess, operationFail } from '../../reducers/operation/action';

/**
 *
 * @param {*} payload
 */
function* importCourseExcelFlow(payload) {
  try {
    const { entity, callback } = payload;
    const response = yield call(importCourseExcelService, entity);

    yield put(operationSuccess());
    yield put(importCourseExcelSuccess(response.data));
    callback(response.data);
  } catch (error) {
    yield put(operationFail(error));
  }
}

/**
 *
 */
export default function* importCourseExcelWatcher() {
  while (true) {
    const action = yield take(IMPORT_COURSE_EXCEL);
    const { payload } = action;

    yield fork(generalSaga, importCourseExcelFlow, payload);
  }
}
